/**
 * Consolidated utilities: domReady, urlParams, personalization, fetchHelper
 * Reduces HTTP requests from 4 separate files to 1
 */
(function() {
  'use strict';

  /* --- dom-ready.js --- */
  window.domReady = function(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };

  /* --- url-params.js --- */
  function capitalizeName(name) {
    if (!name || typeof name !== 'string') return name;
    var trimmed = name.trim();
    if (trimmed.length === 0) return trimmed;
    // Typed in one case ("bella rose", "BELLA"): capitalise each word, split on spaces and hyphens,
    // plus the letter after a single-letter prefix like O' or D' ("o'malley" -> "O'Malley").
    if (trimmed === trimmed.toLowerCase() || trimmed === trimmed.toUpperCase()) {
      return trimmed.toLowerCase().split(/([\s-]+)/).map(function(part) {
        if (!part || /^[\s-]+$/.test(part)) return part;
        var first = part.charAt(0);
        part = first.toUpperCase() + part.slice(1);
        if (part.length > 2 && (part.charAt(1) === "'" || part.charAt(1) === '\u2019') && first.toLowerCase() !== first.toUpperCase()) {
          part = part.slice(0, 2) + part.charAt(2).toUpperCase() + part.slice(3);
        }
        return part;
      }).join('');
    }
    // Mixed case ("McFly", "Bella Rose"): keep exactly what they typed, just start with a capital.
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  }

  window.urlParams = {
    get: function(key, defaultValue) {
      defaultValue = defaultValue === undefined ? null : defaultValue;
      var params = new URLSearchParams(window.location.search);
      var value = params.get(key);
      return value ? decodeURIComponent(value) : defaultValue;
    },
    getMultiple: function(keys) {
      var params = new URLSearchParams(window.location.search);
      var result = {};
      keys.forEach(function(key) {
        var value = params.get(key);
        if (value) {
          result[key] = decodeURIComponent(value);
        }
      });
      return result;
    },
    hasAny: function(keys) {
      var params = new URLSearchParams(window.location.search);
      return keys.some(function(key) { return params.has(key); });
    },
    getQuizData: function() {
      var params = new URLSearchParams(window.location.search);
      var rawName = params.get('dogName') || params.get('name');
      return {
        name: capitalizeName(rawName),
        breed: params.get('breed'),
        age: params.get('age'),
        weight: params.get('weight') || params.get('size'),
        email: params.get('email'),
        issues: params.get('issues') ? params.get('issues').split(',').map(function(i) { return i.trim(); }) : [],
        diet: params.get('diet')
      };
    },
    hasQuizParams: function() {
      var quizKeys = ['dogName', 'name', 'breed', 'age', 'weight', 'size', 'email', 'issues', 'diet'];
      return this.hasAny(quizKeys);
    },
    getPersonalizationData: function() {
      var params = new URLSearchParams(window.location.search);
      var rawName = params.get('name') || params.get('dogName');
      return {
        name: capitalizeName(rawName),
        breed: params.get('breed'),
        age: params.get('age'),
        size: params.get('size')
      };
    }
  };

  /* --- personalization.js --- */
  function escapeHtml(unsafe) {
    if (!unsafe || typeof unsafe !== 'string') return '';
    return String(unsafe)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function pluralizeBreed(breed) {
    if (!breed || typeof breed !== 'string') return breed;
    var trimmed = breed.trim();
    if (trimmed.length === 0) return trimmed;
    var words = trimmed.split(' ');
    var capitalized = words.map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
    if (capitalized.slice(-1) === 's') return capitalized;
    return capitalized + 's';
  }

  window.personalization = {
    fillInputs: function(data) {
      Object.keys(data).forEach(function(id) {
        var input = document.getElementById(id);
        if (input && data[id]) {
          input.value = data[id];
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    },
    selectSizeButton: function(size) {
      if (!size) return;
      var sizeBtns = Array.from(document.querySelectorAll('.size-btn'));
      var targetBtn = sizeBtns.find(function(btn) {
        var btnSize = btn.getAttribute('data-size');
        return btnSize && btnSize.toLowerCase() === size.toLowerCase();
      });
      if (targetBtn) targetBtn.click();
    },
    updateTitle: function(dogName) {
      var title = document.querySelector('.product-single__title');
      if (!title) return;
      var baseTitle = 'Juno Daily';
      title.innerHTML = dogName
        ? baseTitle + ' for <span style="color:#1f2e29; text-decoration:underline; text-decoration-color:#95D5B2;">' + escapeHtml(dogName) + '</span>'
        : baseTitle;
    },
    updateHeadings: function(dogName) {
      var trimmed = dogName && String(dogName).trim()
        ? capitalizeName(String(dogName).trim())
        : '';
      var whyTitle = document.querySelector('.comparison-title');
      if (whyTitle && trimmed) {
        var baseAttr = whyTitle.getAttribute('data-comparison-heading-base');
        var base =
          baseAttr !== null && baseAttr !== ''
            ? baseAttr
            : (whyTitle.textContent || '').trim();
        if (base) {
          if (base.slice(-1) === '?') {
            whyTitle.textContent =
              base.slice(0, -1).replace(/\s+$/, '') + ' for ' + trimmed + '?';
          } else {
            whyTitle.textContent = base.replace(/\s+$/, '') + ' for ' + trimmed;
          }
        }
      }
      var howTitle = document.querySelector('.timeline-heading');
      if (howTitle && trimmed) {
        howTitle.innerHTML =
          "How Will Juno's Supplement Help " + escapeHtml(trimmed) + '?';
      }
    },
    updateFormTitles: function(dogName) {
      var detailsTitle = document.getElementById('dog-details-title');
      if (detailsTitle) detailsTitle.innerText = dogName + "'s details";
      var sizeTitle = document.querySelector('[id*="size"], [class*="size-title"]');
      if (sizeTitle && (sizeTitle.innerText.indexOf("Your dog's size") !== -1 || sizeTitle.innerText.indexOf("Dog's size") !== -1)) {
        sizeTitle.innerText = dogName + "'s Size";
      }
    },
    updateIngredientsHeading: function(dogBreed) {
      if (!dogBreed) return;
      var breedPossessive = dogBreed.slice(-1) === 's' ? dogBreed + "'" : dogBreed + "'s";
      var picHeading = document.querySelector('.pic-heading');
      if (picHeading) picHeading.innerHTML = picHeading.innerHTML.replace(/dog's/gi, escapeHtml(breedPossessive));
      var pluralBreed = pluralizeBreed(dogBreed);
      var allTextElements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6');
      allTextElements.forEach(function(el) {
        var text = el.innerText || el.textContent;
        if (text && (text.indexOf('Ingredients that are GREAT for') !== -1 || text.indexOf('Ingredients that are good for your dog') !== -1)) {
          el.innerText = 'Ingredients that are GREAT for ' + pluralBreed;
        }
      });
    },
    updateFuelBestLife: function(dogName) {
      if (!dogName) return;
      var namePossessive = dogName.slice(-1) === 's' ? dogName + "'" : dogName + "'s";
      var performUpdate = function() {
        var allTextElements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, [class*="title"], [class*="heading"]');
        allTextElements.forEach(function(el) {
          var text = el.innerText || el.textContent;
          if (text && text.trim() === 'Fuel Their Best Life') {
            el.innerText = 'Fuel ' + namePossessive + ' Best Life';
          }
        });
      };
      performUpdate();
      setTimeout(performUpdate, 500);
      setTimeout(performUpdate, 1500);
    },
    updateFoundationBestLife: function(dogName) {
      if (!dogName) return;
      var namePossessive = dogName.slice(-1) === 's' ? dogName + "'" : dogName + "'s";
      var tagline = document.querySelector('.product-tagline');
      if (tagline) {
        var text = tagline.innerText || tagline.textContent;
        if (text && text.indexOf('For their best life, everyday') !== -1) {
          tagline.innerText = 'For ' + namePossessive + ' best life, everyday';
        }
      }
      var allTextElements = document.querySelectorAll('p, .product-tagline, [class*="tagline"]');
      allTextElements.forEach(function(el) {
        var text = el.innerText || el.textContent;
        if (text && text.indexOf('For their best life, everyday') !== -1) {
          el.innerText = text.replace(/For their best life, everyday/gi, 'For ' + namePossessive + ' best life, everyday');
        }
      });
    },
    updateJunoStandard: function(dogBreed) {
      if (!dogBreed) return;
      var pluralBreed = pluralizeBreed(dogBreed);
      var performUpdate = function() {
        var allTextElements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, [class*="title"], [class*="heading"]');
        allTextElements.forEach(function(el) {
          var text = el.innerText || el.textContent;
          if (text && text.trim() === 'The Juno Standard') {
            el.innerText = 'The Juno Standard For ' + pluralBreed;
          }
        });
      };
      performUpdate();
      setTimeout(performUpdate, 500);
      setTimeout(performUpdate, 1500);
    },
    personalizeProductPage: function(data) {
      if (!data.name) return;
      var capitalizedName = capitalizeName(data.name);
      this.fillInputs({
        'juno-dog-name': capitalizedName,
        'juno-dog-breed': data.breed || '',
        'juno-dog-age': data.age || ''
      });
      if (data.size) this.selectSizeButton(data.size);
      this.updateTitle(capitalizedName);
      this.updateHeadings(capitalizedName);
      this.updateFormTitles(capitalizedName);
      this.updateFuelBestLife(capitalizedName);
      this.updateFoundationBestLife(capitalizedName);
      if (data.breed) {
        this.updateIngredientsHeading(data.breed);
        this.updateJunoStandard(data.breed);
      }
    }
  };

  /* --- fetch-helper.js --- */
  window.fetchHelper = {
    fetch: function(url, options, config) {
      options = options || {};
      config = config || {};
      var retries = config.retries || 0;
      var retryDelay = config.retryDelay || 1000;
      var onError = config.onError || null;

      var self = this;
      var attemptFetch = function(attemptNumber) {
        attemptNumber = attemptNumber || 0;
        return fetch(url, options)
          .then(function(response) {
            if (!response.ok) {
              throw new Error('HTTP ' + response.status + ': ' + response.statusText);
            }
            return response;
          })
          .catch(function(error) {
            if (attemptNumber < retries) {
              return new Promise(function(resolve) {
                setTimeout(function() {
                  resolve(attemptFetch(attemptNumber + 1));
                }, retryDelay);
              });
            }
            if (onError && typeof onError === 'function') {
              onError(error, attemptNumber);
            } else {
              console.error('Fetch error:', error);
            }
            throw error;
          });
      };
      return attemptFetch();
    },
    fetchJSON: function(url, options, config) {
      options = options || {};
      config = config || {};
      var self = this;
      return this.fetch(url, options, config)
        .then(function(response) {
          var contentType = response.headers.get('content-type') || '';
          return response.text().then(function(text) {
            try {
              var trimmedText = text.trim();
              if (trimmedText.charAt(0) === '{' || trimmedText.charAt(0) === '[') {
                return JSON.parse(text);
              }
              if (contentType.indexOf('application/json') !== -1 || contentType.indexOf('text/json') !== -1) {
                return JSON.parse(text);
              }
              throw new Error('Invalid response format - expected JSON. Response preview: ' + text.substring(0, 200));
            } catch (parseError) {
              if (parseError instanceof SyntaxError) {
                throw new Error('Failed to parse JSON. Content-Type: ' + (contentType || 'unknown') + '. Preview: ' + text.substring(0, 200));
              }
              throw parseError;
            }
          });
        })
        .catch(function(error) {
          if (config.onError && typeof config.onError === 'function') {
            config.onError(error);
          }
          throw error;
        });
    },
    fetchText: function(url, options, config) {
      options = options || {};
      config = config || {};
      return this.fetch(url, options, config)
        .then(function(response) { return response.text(); })
        .catch(function(error) {
          if (config.onError && typeof config.onError === 'function') {
            config.onError(error);
          }
          throw error;
        });
    },
    post: function(url, data, config) {
      config = config || {};
      var formData = data instanceof FormData ? data : new FormData();
      if (!(data instanceof FormData) && typeof data === 'object') {
        Object.keys(data).forEach(function(key) {
          if (Array.isArray(data[key])) {
            formData.append(key, data[key].join(', '));
          } else {
            formData.append(key, data[key]);
          }
        });
      }
      var options = {
        method: 'POST',
        body: formData
      };
      if (config.fetchOptions) {
        Object.assign(options, config.fetchOptions);
      }
      return this.fetch(url, options, config);
    },
    postJSON: function(url, data, config) {
      config = config || {};
      var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      };
      if (config.headers) Object.assign(options.headers, config.headers);
      if (config.fetchOptions) Object.assign(options, config.fetchOptions);
      return this.fetchJSON(url, options, config);
    }
  };

})();
